import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';

import {
  SUBMIT_TERMINAL_LOGIN_FORM,
  FETCH_LOCATIONS,
  FETCH_TERMINALS,
  terminalLoginAlertBarAction,
  terminalLoginSuccess,
  terminalLoginFailure,
  fetchLocationsSuccess,
  fetchTerminalsSuccess,
  fetchLocationsFailure,
  fetchTerminalsFailure,
} from './TerminalLogin.state';
import {
  loginTerminal,
  transferTerminal,
  fetchLocationsRequest,
  fetchTerminalsRequest,
} from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import { caughtError } from '../../utils/api/errorHandler';

export const caughtTerminalLoginErrorCallback = (state) =>
  caughtError(terminalLoginAlertBarAction, 'Terminal Login Error:', state);

const terminalLoginParams = (state) => ({
  url: getPosApiUrl(state),
  terminal_id: state.terminalLogin.forms.terminalLoginForm.terminal.rawValue,
  token: getAccessToken(state),
});

const transferTerminalParams = (state, email, terminal_session_id) => ({
  url: getPosApiUrl(state),
  email,
  terminal_id: state.terminalLogin.forms.terminalLoginForm.terminal.rawValue,
  terminal_session_id,
  token: getAccessToken(state),
  method: 'PUT',
});

export const submitTerminalLoginFormEpic = (action$, state$) =>
  action$.ofType(SUBMIT_TERMINAL_LOGIN_FORM).pipe(
    RxOp.flatMap((action) => {
      const { isSessionTransfer, email, terminal_session_id } = action.payload;
      if (isSessionTransfer) {
        return Rx.from(
          transferTerminal(
            transferTerminalParams(state$.value, email, terminal_session_id),
          ),
        ).pipe(
          RxOp.flatMap((response) => {
            action.payload.navigate('/pos/products');
            return Rx.of(terminalLoginSuccess(response.data));
          }),
          RxOp.catchError((err) =>
            caughtTerminalLoginErrorCallback(state$.value)(
              err,
              terminalLoginFailure(err.message),
            ),
          ),
        );
      } else {
        return Rx.from(loginTerminal(terminalLoginParams(state$.value))).pipe(
          RxOp.flatMap((response) => {
            action.payload.navigate('/pos/products');
            return Rx.of(terminalLoginSuccess(response.data));
          }),
          RxOp.catchError((err) =>
            caughtTerminalLoginErrorCallback(state$.value)(
              err,
              terminalLoginFailure(err.message),
            ),
          ),
        );
      }
    }),
  );

const fetchLocationsParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});

export const fetchLocationsEpic = (action$, state$) =>
  action$.ofType(FETCH_LOCATIONS).pipe(
    RxOp.flatMap((action) =>
      Rx.from(fetchLocationsRequest(fetchLocationsParams(state$.value))).pipe(
        RxOp.flatMap((response) => Rx.of(fetchLocationsSuccess(response))),
        RxOp.catchError((err) =>
          caughtTerminalLoginErrorCallback(state$.value)(
            err,
            fetchLocationsFailure({
              err: err.message,
              navigate: action.payload.navigate,
            }),
          ),
        ),
      ),
    ),
  );

const fetchTerminalsParams = (state, action) => ({
  url: getPosApiUrl(state),
  locationId: action.payload,
  token: getAccessToken(state),
});

export const fetchTerminalsEpic = (action$, state$) =>
  action$.ofType(FETCH_TERMINALS).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchTerminalsRequest(fetchTerminalsParams(state$.value, action)),
      ).pipe(
        RxOp.flatMap((response) => Rx.of(fetchTerminalsSuccess(response))),
        RxOp.catchError((err) =>
          caughtTerminalLoginErrorCallback(state$.value)(
            err,
            fetchTerminalsFailure(err.message),
            state$.value,
          ),
        ),
      ),
    ),
  );
